import React, { useEffect, useState } from 'react';
import {
  StickyNote, Phone, Video, MessageCircle, Mail, Flag, UserCheck, ListTodo, CheckCircle2, FileText, Eye, XCircle, Sparkles, Pencil,
} from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { fmtDate, errMsg } from './crmConstants';

const ICONS = {
  note: StickyNote, call: Phone, meeting: Video, whatsapp: MessageCircle, email: Mail, email_manual: Mail,
  stage: Flag, assigned: UserCheck, task: ListTodo, task_done: CheckCircle2, offer: FileText, offer_sent: FileText,
  offer_viewed: Eye, offer_accepted: CheckCircle2, offer_declined: XCircle, created: Sparkles, update: Pencil,
};
const KINDS = [
  { id: 'note', label: 'Nota' }, { id: 'call', label: 'Telefonata' }, { id: 'meeting', label: 'Call video' },
  { id: 'whatsapp', label: 'WhatsApp' }, { id: 'email_manual', label: 'Email manuale' },
];

export const LeadTimeline = ({ api, lead, showToast, onChanged, refreshKey }) => {
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState('note');
  const [detail, setDetail] = useState('');
  const load = () => api.get(`/admin/leads/${lead.id}/timeline`).then(setItems).catch(() => {});
  useEffect(() => { load(); }, [lead.id, refreshKey]);

  const add = async () => {
    try {
      await api.post(`/admin/leads/${lead.id}/activities`, { type: kind, detail });
      setDetail(''); load(); onChanged();
    } catch (e) { showToast('error', errMsg(e)); }
  };

  return (
    <div className="space-y-4" data-testid="lead-timeline">
      <div className="bg-slate-800/60 border border-slate-700 rounded-xl p-3 space-y-2">
        <div className="flex flex-wrap gap-1.5">
          {KINDS.map((k) => (
            <button key={k.id} type="button" onClick={() => setKind(k.id)} className={`text-xs px-2.5 py-1 rounded-full ${kind === k.id ? 'bg-amber-500 text-slate-950 font-semibold' : 'bg-slate-700 text-slate-200 hover:bg-slate-600'}`} data-testid={`activity-kind-${k.id}`}>{k.label}</button>
          ))}
        </div>
        <textarea value={detail} onChange={(e) => setDetail(e.target.value)} rows={2} placeholder="Cosa è successo? (es. Interessato, richiamare a fine mese)" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm" data-testid="activity-detail-input" />
        <div className="flex justify-end">
          <Button size="sm" onClick={add} disabled={!detail.trim() && kind === 'note'} className="bg-amber-500 hover:bg-amber-400 text-slate-950" data-testid="activity-add-btn">Registra</Button>
        </div>
      </div>
      <ol className="relative border-l border-slate-700 ml-3 space-y-4">
        {items.map((a) => {
          const Icon = ICONS[a.type] || StickyNote;
          const strong = ['offer_accepted', 'offer_viewed', 'stage'].includes(a.type);
          return (
            <li key={a.id} className="ml-5" data-testid={`timeline-item-${a.id}`}>
              <span className={`absolute -left-3 w-6 h-6 rounded-full flex items-center justify-center ring-4 ring-slate-900 ${a.type === 'offer_accepted' ? 'bg-emerald-500 text-white' : strong ? 'bg-amber-500 text-slate-950' : 'bg-slate-700 text-slate-200'}`}>
                <Icon className="w-3 h-3" />
              </span>
              <p className="text-sm text-white">{a.title}</p>
              {a.detail && <p className="text-xs text-slate-400 whitespace-pre-wrap break-words">{a.detail}</p>}
              <p className="text-[11px] text-slate-500 mt-0.5">{fmtDate(a.at)}{a.by_name ? ` · ${a.by_name}` : ''}</p>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
